export const LIMITED_ACCESS_LIST = [
    { name: 'Construction Site', value: 'construction-site' },
    { name: 'Individual (Mini) Storage Unit', value: 'mini-storage-unit' },
    { name: 'Fair/Amusement Park', value: 'fair' },
    { name: 'Place of Worship', value: 'place-of-worship' },
    { name: 'Farm/Country Club/Estate', value: 'farm' },
    {
        name: 'Secured Locations Delivery - prisons, military bases, airport',
        value: 'secured-location',
    },
    { name: 'School/University', value: 'school' },
    { name: 'Plaza/Mall with only parking lot/Street access', value: 'mall' },
    { name: 'Airport', value: 'airport' },
    { name: 'Cemetery', value: 'cemetery' },
    { name: 'Church', value: 'church' },
    { name: 'Convention Center', value: 'convention-center' },
    { name: 'Funeral Home', value: 'funeral-home' },
    { name: 'Golf Course', value: 'golf-course' },
    { name: 'Grocery Warehouse', value: 'grocery-warehouse' },
    { name: 'Hospital/Medical Facility', value: 'hospital-medical-facility' },
    { name: 'Hotel', value: 'hotel' },
    { name: 'Inspection Site', value: 'inspection-site' },
    { name: 'Marina', value: 'marina' },
    { name: 'Military Base', value: 'military-base' },
    { name: 'Mine Site', value: 'mine-site' },
    { name: 'No Dock/Dock obstruction', value: 'no-dock-dock-obstruction' },
    { name: 'Nursing Home', value: 'nursing-home' },
    { name: 'Park Forest/Preserve', value: 'park-forest-preserve' },
    { name: 'Piers and Wharves', value: 'piers-and-wharves' },
    { name: 'Prison', value: 'prison' },
    { name: 'Ranch', value: 'ranch' },
    {
        name: 'Recreational/athletic Facility',
        value: 'recreational-athletic-facility',
    },
    { name: 'Remote Government', value: 'remote-government' },
    { name: 'Reservation', value: 'reservation' },
    { name: 'Restaurant', value: 'restaurant' },
    { name: 'Service Station', value: 'service-station' },
    { name: 'Social Club', value: 'social-club' },
    { name: 'Steel Mill', value: 'steel-mill' },
    { name: 'Unspecified', value: 'unspecified' },
    { name: 'Utility Site', value: 'utility-site' },
    { name: 'Winery/Brewery/Distillery', value: 'winery-brewery-distillery' },
    { name: 'Other', value: 'other' },
];

export const initAction = {
    mode: '',
    shipper: false,
    consignee: false,
    tailgate: false,
    unusual: false,
    service: false,
    delivery: false,
    limitedAccess: false,
};

export const shipperFormKeys: Record<string, string> = {
    shipperFullAddress: 'fullAddress',
    shipperAddress1: 'address1',
    shipperCity: 'city',
    shipperState: 'state',
    shipperCountry: 'country',
    shipperPostal: 'postal',
    shipperLatitude: 'latitude',
    shipperLongitude: 'longitude',
    shipperStateCode: 'stateCode',
    shipperCountryCode: 'countryCode',
    shipperStreetNumber: 'streetNumber',
    shipperCompanyName: 'companyName',
};

export const consigneeFormKeys: Record<string, string> = {
    consigneeFullAddress: 'fullAddress',
    consigneeAddress1: 'address1',
    consigneeCity: 'city',
    consigneeState: 'state',
    consigneeCountry: 'country',
    consigneePostal: 'postal',
    consigneeLatitude: 'latitude',
    consigneeLongitude: 'longitude',
    consigneeStateCode: 'stateCode',
    consigneeCountryCode: 'countryCode',
    consigneeStreetNumber: 'streetNumber',
    consigneeCompanyName: 'companyName',
};

export const TAILGATE_SERVICE_IDS = [1, 7];

export const DEFAULT_COMMODITIES = ['Dry Freight', 'Construction Equipment', 'Produce (Fresh)', 'Machinery'];
